  $(document).on("click",'.addtocartRus', function(event) {
    event.preventDefault();
    window.location.href ='https://teabox.com/';
  });

  $(document).on("click",".nav_right_bar .special_product",function(e) {
    $('#product_page .main_add .product_form .special_product .product-single__add-to-cart').click();
    $('#product_page .main_add .product_form .special_product .product-single__add-to-cart .add_to_cart').text('Secure Checkout');
  });
//quick-view
$(document).on("click",".quick-view-product",function(event) {
  var parent = $(this).closest('.tb-list-pdt');
  var rating = $(".rating-cnt>span",parent).html();
  $(".quick-popup-main").show();
  $("#LoadIconForPop").show();
  var product = $(this).attr("data-handle");
  var quick_view = $(".quick-popup-main #quick_view");
  if(quick_view.length == 0){
    var quick_view = $("#myModalPop .quick_view_area");
  }

  var url = "/products/"+product+'?view=quickview';
  $.ajax({
    url: url,
    success: function(data) {
      var data =  $(data);
      quick_view.html("");
      quick_view.append(data.html());
      simply.productVariantInitialize();
      var flex = quick_view.find(".flexslider");
      simply.product_page_slider(flex);
      $(".rating-cnt>span",quick_view).html(rating);
      $("#LoadIconForPop").hide();
      
      simply.shippinDetails();
      
    }
  });
});

// shipping_details
simply.shippinDetails =  function(){
  if($("#searchresults").length > 0){
    var cc_code = $('#dv-flag-holder').attr('data-country-id');
    if(cc_code){
      var cc_up = cc_code.toUpperCase();
    }
  }
  else{
    function getCookie(cname) {
      var name = cname + "=";
      var decodedCookie = decodeURIComponent(document.cookie);
      var ca = decodedCookie.split(';');
      for(var i = 0; i <ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == '') {
          c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
          return c.substring(name.length, c.length);
        }
      }
      return "";
    }
    var cc_code = simply.getCookie("us_con").toLowerCase();
    if(cc_code != ""){
      var cc_up = cc_code.toUpperCase();
    } else {
      var cc_up = simply.getCookie('user_cc')
    }
  }
  var price = $("#ProductPrice").attr("data-base-amount");
  $.ajax({
    url: 'https://apps.teabox.com/shipping/get_delivery_date/',
    type: 'POST',
    dataType: 'json',
    data:{
      "country": cc_up,
      "price": price,
      "currency": "INR"
    },
    success: function(data) {
      $(".ForDelDate").remove();
      $(".address_section").append('<p class="ForDelDate">Ships in 24 Hours. </br>Delivers to <span class="ship-loc"><u></u></span> by <span class="dil-date"></span></p>');
      $( ".ForDelDate" ).insertBefore( ".view-PrdRv" );
      $("#ship-loc u").html(data.country);
      $(".hidden-xs #dil-date").html(data.delivers_by);
      $(".visible-xs #dil-date").html(data.delivers_by);
      $(".dil-date").html(data.delivers_by);
      $(".dil-date").html(data.delivers_by);

      $('.pdt-ship-cnt').show();
    }
  });
};
//product swatches
$(document).on("click",".swatch-element",function(){
  simply.productSwatchesChange($(this), true);
  $("#Quantity").val(1).trigger('change');
  if($(".nav_right_bar .add_to_cart_link").length>0){
    $(".nav_right_bar .add_to_cart_link").html($("#AddToCart").attr('data-text'));
    $(".nav_right_bar .add_to_cart_link").removeAttr('href');
  }
  if($(".swatches").hasClass('color-swatches')){
    $(".variant_color_name").html($(this).attr("data-value"));
    $(".special_teaware_details .color_name").html($(this).attr("data-value"));
    $(".special_teaware_details .color_name_image").attr('src', $(this).attr("data-src"));
    $(".special_teaware_details .sku_details_text").html($(this).attr("data-sku"));
  }
  $(".spinner .js-quantity-selector").val("1");
  $(".spinner .js-quantity-selector").trigger('change');

  $('.money').each(function(index, el) {
    var str = $(this).text().trim()[0] + '' + $(this).text().trim().slice(1);
    var symbol = $('.currency_symbol .symbol').text();
    if($('.currency_symbol .symbol').length == 0)
    {
     $(this).html(str);
   }
   else{
    if($(this).text().indexOf(symbol) != 0){
      $(this).html(str);
      $(this).prepend(symbol);
    }
  }
});
});

//spinner
$(document).on("change",".spinner .js-quantity-selector",function(){
  var value = $(this).val();
  var price = $("#Quantity").attr("data-price");
  var compareprice = $("#Quantity").attr("data-compareprice");
  $("#Quantity").attr("value",value);
  var fprice = value * parseInt($(this).attr('data-price')) ;
  var cprice = value * parseInt($(this).attr('data-compareprice')) ;
  $("#ProductPrice").attr("data-base-amount",fprice/100);
  $("#ComparePrice").attr("data-base-amount",cprice/100);
  $("#ProductPrice").html(Shopify.formatMoney(fprice,simply.moneyFormat).replace(/((\,00)|(\.00))$/g, ''));
  var str = $("#ProductPrice").text()[0] + '' + $("#ProductPrice").text().slice(1);
  var symbol = $('.currency_symbol .symbol').text();
  $("#ProductPrice").html(str);
  $("#ProductPrice").prepend(symbol);
  $('#ComparePrice').html(Shopify.formatMoney(cprice,simply.moneyFormat).replace(/((\,00)|(\.00))$/g, ''));
  $(".product_price_mobile").html(str);
  $(".product_price_mobile").prepend(symbol);
var str = $("#ComparePrice").text()[0] + '' + $("#ComparePrice").text().slice(1);
var symbol = $('.currency_symbol .symbol').text();
$("#ComparePrice, .compare_price_mobile").html(str);
$("#ComparePrice, .compare_price_mobile").prepend(symbol);

if($(".product-extra-content .tb-cnt div").hasClass('nav_right_bar')){
  $(".nav_right_bar #ProductPrice").attr("data-base-amount",fprice/100);
  $(".nav_right_bar #ComparePrice").attr("data-base-amount",cprice/100);
  $(".nav_right_bar #ProductPrice").html(Shopify.formatMoney(fprice,simply.moneyFormat).replace(/((\,00)|(\.00))$/g, ''));
  $('.nav_right_bar #ComparePrice').html(Shopify.formatMoney(cprice,simply.moneyFormat).replace(/((\,00)|(\.00))$/g, ''));
}
// var href = window.location.href;
// var curr_currency = $('#current-currency').val();

// if(href.indexOf('https://www.teabox.com/') !=  -1){
//   if(curr_currency == 'EUR'){
//     var f_price = fprice,
//     f_price = f_price.toString().replace('.', ','),
//     c_price = cprice,
//     c_price = c_price.toString().replace('.', ',');

//     // $productPrice.attr("data-base-amount", var_price);
//     $(".product_price_mobile").attr("data-base-amount",f_price);
//     $(".compare_price_mobile").attr("data-base-amount",c_price/100);
//     $(".product_price_mobile").html(Shopify.formatMoney(f_price,simply.moneyFormat).replace(/((\,00)|(\.00))$/g, ''));
//     $('.compare_price_mobile').html(Shopify.formatMoney(c_price,simply.moneyFormat).replace(/((\,00)|(\.00))$/g, ''));
//   }
// }
// else{
//   $(".product_price_mobile").attr("data-base-amount",fprice/100);
//   $(".compare_price_mobile").attr("data-base-amount",cprice/100);
//   $(".product_price_mobile").html(Shopify.formatMoney(fprice,simply.moneyFormat).replace(/((\,00)|(\.00))$/g, ''));
//   $('.compare_price_mobile').html(Shopify.formatMoney(cprice,simply.moneyFormat).replace(/((\,00)|(\.00))$/g, ''));

// }

$(".pdt-disc").html(Math.floor((((cprice/100) - (fprice/100))/(cprice/100))*100)+ "% off");
if ( cprice <= fprice ){
  $("#ComparePrice").attr("data-base-amount","");
  $('#ComparePrice').html("");
  $(".compare_price_mobile").attr("data-base-amount","");
  $('.compare_price_mobile').html("");
  $(".pdt-disc").addClass("hidden");
  $('#ComparePrice').addClass('hidden');
  $('.compare_price_mobile').addClass('hidden');
  if($(".product-extra-content .tb-cnt div").hasClass('nav_right_bar')){
    $('.nav_right_bar #ComparePrice').addClass('hidden');
  }
}
else{
  $(".pdt-disc").removeClass('hidden');
  $(".pdt-disc").css('display', 'inline-block');
  $('#ComparePrice').removeClass('hidden');
  $('.nav_right_bar #ComparePrice').removeClass('hidden');
  if($(".product-extra-content .tb-cnt div").hasClass('nav_right_bar')){
    $('.compare_price_mobile').removeClass('hidden');
  }

}
});
$(document).on("click",".spinner .plus",function(){
  var target = $(this).siblings("input");
  var iqty= $("#Quantity").attr("data-iqty");
  var value = parseInt(target.val());
  if(value < iqty){
    var value = parseInt(target.val()) + 1;
    target.val(value);
    target.trigger('change');
  }
  $('.product_price .old-price-span ').each(function(index, el) {
    var str = $(this).text().trim()[0] + '' + $(this).text().trim().slice(1);
    var symbol = $('.currency_symbol .symbol').text();
    if($('.currency_symbol .symbol').length == 0)
    {
     $(this).html(str);
   }
   else{
    if($(this).text().indexOf(symbol) != 0){
      $(this).html(str);
      $(this).prepend(symbol); 
    }
  }
});
  $('.money').each(function(index, el) {
    var str = $(this).text().trim()[0] + '' + $(this).text().trim().slice(1);
    var symbol = $('.currency_symbol .symbol').text();
    if($('.currency_symbol .symbol').length == 0)
    {
     $(this).html(str);
   }
   else{
    if($(this).text().indexOf(symbol) != 0){
      $(this).html(str);
      $(this).prepend(symbol);
    }
  }
});
});
$(document).on("click",".spinner .min",function(){
  var target = $(this).siblings("input");
  var value = parseInt(target.val());
  if(value > 1){
    var value = value - 1;
    target.val(value);
    target.trigger('change');
  }

  $('.product_price .old-price-span ').each(function(index, el) {
    var str = $(this).text().trim()[0] + '' + $(this).text().trim().slice(1);
    var symbol = $('.currency_symbol .symbol').text();
    if($(this).text().indexOf(symbol) != 0){
      $(this).html(str);
      $(this).prepend(symbol);
    }
  });

});

$(document).on("click",".quick-popup-main .product-close",function(event) {
  $(".quick-popup-main").hide();
});

simply.searchAjaxCart =  function(form,button){
  button.html("<img src='https://cdn.shopify.com/s/files/1/1865/1011/files/loading-img.gif?1026996227552849345' class='product-animation' />");
  if($(".nav_right_bar .add_to_cart_link").length>0){
    $(".nav_right_bar .add_to_cart_link").html("<img src='https://cdn.shopify.com/s/files/1/1865/1011/files/loading-img.gif?1026996227552849345' class='product-animation' />");
  }
  var qty = $("#Quantity",form).val();
  var data = form.serialize();
  if(data == ""){
    var id = parseInt($('.single_variants option').attr('value'));
    data = "id="+id+"&quantity=1";
  }
  var params = {
    type: 'POST',
    url: '/cart/add.js',
    data: data,
    dataType: 'json',
    success: function(line_item) {
      $('.nav_right_bar .special_product .add_to_cart').text('Secure Checkout')
      var currency = '';
      total_price += line_item.final_price * parseInt(qty) / 100;
      if($('#current-currency').val() == 'INR') {
      }
      else{
        
        $("#total_cart_money").html(currency + total_price);
        
      }
      $("#total_cart_money").addClass('money');
      button.html("<img src=//cdn.shopify.com/s/files/1/1865/1011/t/47/assets/loading-img.gif?3720135459961533615 class='product-animation' />");
      $(".image_block").append('<div class="addbutton"></div>')
      $(".addbutton").html("<span><img src='//teabox-multi-currency.myshopify.com/cdn/shop/t/10/assets/check1.png?v=96242143331653865171570100819' alt='Checkmark' /></span> Added to your cart.");
      $(".addbutton").show();
      if($(".nav_right_bar .add_to_cart_link").length>0){
        $(".nav_right_bar .add_to_cart_link").html("secure checkout");
        $(".nav_right_bar .add_to_cart_link").attr('href', '/checkout');
      }
      if($("#searchresults").length > 0){
        button.text('Go To Cart');
        button.removeAttr( "onclick" );
        button.click(function(){
          button.attr("type","button");
          setTimeout(function(){
            window.location.href = "/checkout";
          }, 200);
        });
      }
      else{
        var shop = window.location.href;    button.text("Secure Checkout");
        var ru = 'ru.teabox.com';
        if(shop.indexOf(ru) != -1){
          var checkout_text = "Безопасная система оплаты";
        }
        else{
          var checkout_text = "Secure Checkout";
        }
        button.removeAttr( "onclick" );
        button.click(function(){
          button.attr("type","button");
          setTimeout(function(){
            window.location.href = "/checkout";
          }, 200);
        });
      }
      $.get("/cart?view=quick",function(data){
        data = $(data);
        var count = $(".cart_count",data).text();
        var price = $(".cart_price",data).attr('data-base-amount');
        var symbol = $('.currency_symbol .symbol').text();
        $("#total_cart_money").text(price);
        var href = window.location.href;
        var curr_currency = $('#current-currency').val();
        if(href.indexOf('https://www.teabox.com/') !=  -1){
          if(curr_currency == 'JPY'){
            $("#total_cart_money").prepend(symbol +'¥ ');
          }
          else if(curr_currency == 'EUR'){
            $("#total_cart_money").prepend(symbol +'€ ');
          }
          else if(curr_currency == 'GBP'){
            $("#total_cart_money").prepend(symbol +'£ ');
          }
          else{
            $("#total_cart_money").prepend(symbol +'$ ');
          }
        }
        if(curr_currency == 'INR') {
          $("#total_cart_money").prepend(symbol +'₹ ');
        }
        $("#total_cart_money").attr("data-base-amount",$(".cart_price",data).attr("data-base-amount"));
// simply.callCurrency();
$("#cart-length-sp").removeClass("cart_grey").addClass("cart_green").text(count);
$(".mobile_cart_count").removeClass("cart_grey").text(count);
var cart_drawer = $("#cart_drawer",data);
$("#cart_drawer").html(cart_drawer.html());
});
    },
    error: function(XMLHttpRequest, textStatus) {
      var error=  JSON.parse((XMLHttpRequest.responseText)).description;
      console.log(error);
    }
  };
  jQuery.ajax(params);
};
$(document).on("submit",".searchAjaxCart",function(e){
  e.preventDefault();
  var form = $(this);
  var button = $(".buy_me",form);
  simply.searchAjaxCart(form,button);
});
simply.productSwatchesInit = function(parent){
  if($(".swatches").length > 0){
    parent.find(".single-option-selector").each(function(index,item){
      var value = $(item).val();
      var target = $(item).attr("data-option");
      target = target.replace("option","");
      target = parseInt(target) - 1;
      var select = parent.find(".swatch[data-option-index='"+target+"']");
      select.find(".swatch-element[data-value='"+value+"']").addClass("active");
    });

    parent.find(".swatches").each(function(){
      if($(this).find(".swatch-element").length < 2){
// $(this).hide();
}
});
    if($("#product_page .hide_sold_out").length > 0){
      simply.linkOptionSelectors(simply.productJson);
    }
  }
};

simply.linkOptionSelectors = function(product) {
  var product_id = product.id;
  var parent = $(".card_"+product_id);
// Building our mapping object.
var optionsMap = {};
simply.productoptionsMap[product_id] = optionsMap;
for (var i=0; i<product.variants.length; i++) {
  var variant = product.variants[i];
  if (variant.available) {
// Gathering values for the 1st drop-down.
optionsMap['root'] = optionsMap['root'] || [];
optionsMap['root'].push(variant.option1);
optionsMap['root'] = Shopify.uniq(optionsMap['root']);
// Gathering values for the 2nd drop-down.
if (product.options.length > 1) {
  var key = variant.option1;
  optionsMap[key] = optionsMap[key] || [];
  optionsMap[key].push(variant.option2);
  optionsMap[key] = Shopify.uniq(optionsMap[key]);
}
// Gathering values for the 3rd drop-down.
if (product.options.length === 3) {
  var key = variant.option1 + ' / ' + variant.option2;
  optionsMap[key] = optionsMap[key] || [];
  optionsMap[key].push(variant.option3);
  optionsMap[key] = Shopify.uniq(optionsMap[key]);
}
}
}
// Update options right away.
simply.updateOptionsInSelector(0, product_id);
if (product.options.length > 1) simply.updateOptionsInSelector(1,product_id);
if (product.options.length === 3) simply.updateOptionsInSelector(2, product_id);
// When there is an update in the first dropdown.
parent.find(".single-option-selector:eq(0)").change(function() {
  simply.updateOptionsInSelector(1, product_id);
  if (product.options.length === 3) simply.updateOptionsInSelector(2, product_id);
  return true;
});
// When there is an update in the second dropdown.
parent.find(".single-option-selector:eq(1)").change(function() {
  if (product.options.length === 3) simply.updateOptionsInSelector(2, product_id);
  return true;
});
};
simply.productVariantInitialize = function(){
  if(!cn(simply.productJson)){
    var selectProductId = "ProductSelect_"+simply.productJson.id;
    var selectProductIdMobile = "ProductSelectXS_"+simply.productJson.id;
    if($('#'+selectProductId).length > 0){
      var callBack = window["selectCallback_"+simply.productJson.id];
      new Shopify.OptionSelectors(selectProductId, {
        product: simply.productJson,
        onVariantSelected: callBack ,
        enableHistoryState: true
      });
      if($(selectProductIdMobile).length>0){
        var callBack = window["selectCallback_"+simply.productJson.id];
        new Shopify.OptionSelectors(selectProductIdMobile, {
          product: simply.productJson,
          onVariantSelected: callBack ,
          enableHistoryState: true
        });
      }
      var parent = $(".card_"+simply.productJson.id);
//       simply.productSelectHide();
simply.productSwatchesInit(parent);
$("#product_card .selector-wrapper select").each(function(index,item){
  if($(item).children().length > 1){
    $(item).parent().show();
  }
  else{
    $(item).parent().hide();
  }
});
};
}
};

simply.product_page_slider = function(selector){
  selector.flexslider({
    animation: "slide",
    itemWidth: 380,
    slideshow: false
  });
};

simply.productCallback = function (options) {
  var moneyFormat = options.money_format,
  variant = options.variant,
  selector = options.selector,
  translations = options.translations;
// Selectors
var parent_id = $('#'+options.selector.domIdPrefix).data('productid');
var parent = $(".card_"+parent_id);
var $addToCart = parent.find('#AddToCart'),
$productPrice = parent.find('#ProductPrice'),
$comparePrice = parent.find('.old-price-span'),
$inventory = parent.find("#ProductInventory"),
$quantityElements = parent.find('.js-quantity-selector, label + .js-qty'),
$product_img = parent.find("#ProductImages");
$addToCartText = parent.find('#AddToCartText');
var fqty =  $("#Quantity").attr("value");
if($comparePrice.length == 0){
  $comparePrice = $("#ComparePrice",parent);

}
if(cn(simply.product_page_slider)){
  simply.initProductSlider();
}
if (variant) {
// Update variant image, if one is set
if (variant.featured_image) {
  ;
  var imgObj = variant.featured_image;
  var new_img = imgObj.id;
  new_img = ".id_"+new_img;
  var index = $product_img.find(new_img).attr("data-index");
  if(!cn(index)){
    index = parseInt(index) - 1;
    simply.product_page_slider.goToSlide(index);
  }
}
for (var i=0,length=variant.options.length; i<length; i++) {
  var option = variant.options[i];
  var swatch = $('.swatch-element[data-value="'+option+'"]', parent);
  simply.productSwatchesChange(swatch, false);
}
simply.getCurrentIpadVariant();
// Select a valid variant if available
if (variant.available) {
  if(!cn(variant.inventory_management)){
    $inventory.html(variant.inventory_quantity +" "+translations.inStock);
  }
// Available, enable the submit button, change text, show quantity elements
$addToCart.removeClass('disabled').prop('disabled', false);
$addToCartText.html(translations.addToCart);
$quantityElements.show();
$quantityElements.attr("disabled",false);
} else {
// Sold out, disable the submit button, change text, hide quantity elements
$addToCart.addClass('disabled').prop('disabled', true);
$addToCartText.html(translations.soldOut);
$quantityElements.attr("disabled",true);
if(!cn(variant.inventory_management)){
  $inventory.html("");
}
}
$("#Quantity").attr("data-iqty",variant.inventory_quantity);
$("#Quantity").attr("data-price",variant.price);
$("#Quantity").attr("data-compareprice",variant.compare_at_price);

var curr_currency = $('#current-currency').val();
var href = window.location.href;
if(href.indexOf('https://www.teabox.com/') !=  -1){
  if(curr_currency == 'EUR'){
    var var_price = (variant.price / 100);
    var_price = var_price.toString().replace('.', ',');
    $productPrice.attr("data-base-amount", var_price);
  }
}
else{
  $productPrice.attr("data-base-amount",(variant.price / 100));
}
$productPrice.html(Shopify.formatMoney((variant.price * fqty), moneyFormat).replace(/((\,00)|(\.00))$/g, ''));
var str = $productPrice.text().slice(1);
var symbol = $('.currency_symbol .symbol').text();
if(location.host == 'www.teabox.com'){
  if(curr_currency == 'JPY'){
    var str = $productPrice.attr("data-base-amount");
    $productPrice.html(str);
    $productPrice.prepend('¥ '); 
  }
  else if(curr_currency == 'EUR'){
    var str = (Shopify.formatMoney((variant.price * fqty), moneyFormat));
    $productPrice.html(str);
    $('.orignal.money.product_price_mobile').html(str);
    $('.product_price.money.product_price_mobile').html(str);
  }
  else if(curr_currency == 'GBP'){
    var str = $productPrice.attr("data-base-amount");
    $productPrice.html(str);
    $productPrice.prepend('£ '); 
  }
  else{
    $productPrice.html(str);
    $productPrice.prepend('$ ');
    $productPrice.prepend(symbol);
    $('.orignal.money.product_price_mobile').html(str);
    $('.product_price.money.product_price_mobile').html(str);
    $('.orignal.money.product_price_mobile').prepend('$ ')
    $('.product_price.money.product_price_mobile').prepend('$ ')
    $('.orignal.money.product_price_mobile').prepend(symbol);
    $('.product_price.money.product_price_mobile').prepend(symbol);
  }
}
// Also update and show the product's compare price if necessary

if (variant.compare_at_price > variant.price) {
  var symbol = $('.currency_symbol .symbol').text();
  $comparePrice.html(Shopify.formatMoney(variant.compare_at_price * fqty, moneyFormat).replace(/((\,00)|(\.00))$/g, ''));
  $comparePrice.prepend(symbol);
  var str =   $("#ComparePrice").attr("data-base-amount");
  var href = window.location.href;
  if(href.indexOf('https://www.teabox.com/') !=  -1 && !cn(str)){
    if($('#quick_view').length == 0){
      if(str.indexOf(symbol) != 0 ){
        var curr_currency = $('#current-currency').val();
        var href = window.location.href;
        if(href.indexOf('https://www.teabox.com/') !=  -1){
          if(curr_currency == 'EUR'){
           var compare_price = (Shopify.formatMoney((variant.compare_at_price * fqty), moneyFormat));
           compare_price = compare_price.slice(1);
           var compare_price = compare_price.toString().replace('.', ',');
           $comparePrice.html(compare_price);
           $comparePrice.prepend('€ ');
         }
       } 
       else{
        $comparePrice.html(str);
      }
    }
    else{
      $comparePrice.prepend(symbol);
      if($('.currency_option.active').attr('data-currency') == 'EUR'){
        var compare_price = (Shopify.formatMoney((variant.compare_at_price * fqty), moneyFormat));
        compare_price = compare_price.slice(1);
        var compare_price = compare_price.toString().replace('.', ',');
        $comparePrice.html(compare_price);
        $comparePrice.prepend('€ ');
      }
    }
  }
}
$productPrice.addClass('on-sale');
} else {
  $productPrice.removeClass('on-sale');
  $comparePrice.html("");
  var symbol = $('.currency_symbol .symbol').text();
  $('#ComparePrice').attr('data-base-price', 0);
  $('#ComparePrice').attr('data-base-amount', variant.compare_at_price);
  $('#ComparePrice').attr('data-base-price', variant.compare_at_price);
  $("#Quantity").attr("data-compareprice",variant.compare_at_price);

}
}
else {
// The variant doesn't exist, disable submit button.
// This may be an error or notice that a specific variant is not available.
// To only show available variants, implement linked product options:
//   - http://docs.shopify.com/manual/configuration/store-customization/advanced-navigation/linked-product-options
$addToCart.addClass('disabled').prop('disabled', true);
$comparePrice.html("");
var str = $comparePrice.text()[0] + '' + $comparePrice.text().slice(1);
var symbol = $('.currency_symbol .symbol').text();
$comparePrice.html(str);
$comparePrice.prepend(symbol);

$addToCartText.html(translations.unavailable);
$quantityElements.attr("disabled",true);
}
// simply.callCurrency();
selectCallback();
};
window.selectCallback = simply.selectCallback = function(){

}
simply.productSwatchesChange = function(selector, trigger){
  selector.siblings().removeClass("active");
  selector.addClass("active");
  if(trigger){
    var target = selector.attr("data-value");
    var parent = selector.parent();
    var product = parent.attr("data-id");
    var oi = parent.attr("data-option-index");
    oi = parseInt(oi) + 1;
    oi = "option"+oi;
    var select = $("."+product).find(".single-option-selector[data-option='"+oi+"']");
    select.val(target).trigger('change');
    simply.swapTinboximg(selector);
  }
};
window.selectCallback = simply.selectCallback = function(){

}

// end quick-view
function addItem(form_id) {
// getting the product form data.

var product_id = 0;
var variant_id = 0;
var quantity_ = 0;
product_id = $("#cart_form_product_id").val();
variant_id = $("#cart_form_variant_id").val();
quantity_ = $("#cart_form_quantity").val();
// displaying the modal for updating.

$('.modal').html('UPDATING...');
openModal();
// setTimeout(autocloseModal(), 3000);
// alert(variant_id);

// Ajax request for saving the product to cart.

$.ajax({
  type: 'POST',
  url: '/cart/add.js',
  dataType: 'json',
  data: { "quantity": parseInt(quantity_), "id": parseInt(variant_id) },
  success: function(cart_item) {

// if successful

console.log("cart_item");
console.log(cart_item);

// saving the current items number in cart, changing the values of money,items number of cart menu and changing the css of cart menu.

var temp_cartCount = total_count;
total_count += parseInt(quantity_);

$("#cart-length-sp").html(total_count);
$("#cart-length-sp").removeClass("cart_grey");
$("#cart-length-sp").addClass("cart_green");
total_price += cart_item.price * parseInt(quantity_) / 100;
$("#total_cart_money").html('Rs.' + total_price);
$("#total_cart_money").addClass("color-green");
$("#sub_total_lb").html('Sub Total ' + 'Rs.' + total_price);


// if just added variant be already in cart, increase only quantity and display this.

var str_temp = '';
var survive_flag = 0;
if ($("#item"+cart_item.id+" .col-sm-8 #item_qty_gm").html())
{
	survive_flag = 1;
	$("#item"+cart_item.id+" .col-sm-8 #item_qty_gm").html("QTY: "+cart_item.quantity+" | "+cart_item.grams+" g");
	$("#item"+cart_item.id).removeClass("wer");
	$("#empty_cart_mine").addClass("wer");
	$("#cart_drawer_footer").removeClass("wer");
}


// if just added variant be not in cart, insert this to cart and display as <li>

if (survive_flag == 0)
{

		// Ajax request for getting the current items number

		var item_length = 0;
		console.log("add_new");
		$.ajax({
      type: 'GET',
      url: '/cart.js',
      dataType: 'json',
      data: {},
      success: function(cart_items) {

		// if success

		// getting the current items number

		var b = 0;
		while(cart_items.items[b])
		{
			item_length++;
			b++;
		}
		console.log("item length" + item_length);

		$("#cart_drawer_headline").html("Shopping Cart");

		// current items number will be compared with 3,
		str_temp = '<li id="item' + cart_item.id + '" class="cart-drawer-body new_mine" style="border-bottom: solid 1px grey !important;">' + '<div class="col-sm-3" style="padding:0px; padding-right:10px;">' + '<img class="col-sm-12" src="' + cart_item.image + '">' + '</div><div class="col-sm-8" style="padding: 0px;">' + '<h6 style="display:inline-block;">' + cart_item.title + '</h6>' + '<label id="item_qty_gm">QTY: ' + cart_item.quantity + ' | ' + cart_item.grams + ' g</label><br>' + '<label>Rs. ' + cart_item.price/100 + '</label><br><br>' + '<a href="#"><b class="color-green"><em>In Stock</em></b></a></div><div class="col-sm-1" style="float: right !important;">' + '<h6 id="btn_item' + cart_item.id + '" style="float: right !important; cursor: pointer;">X</h6></div></li>';

		// the javascript functions for just added cart items (deleting item, change attributes of cart menu and submenu and so forth)

		str_temp += '<script>$("#btn_item' + cart_item.id + '").click(function(){ var temp_items;  var item_id_mine = ' + cart_item.id + ';';
   str_temp += '$.ajax({type: "GET",url: "/cart.js",dataType: "json",data: {},success: function(results) {var p = 0;while (results.items[p])';
   str_temp += '{if (item_id_mine == results.items[p].id){delete_quantity(item_id_mine);return;total_count = total_count - results.items[p].quantity;';
   str_temp += 'total_price = total_price - results.items[p].price * results.items[p].quantity / 100;$("#cart-length-sp").html(total_count);';
   str_temp += '$("#total_cart_money").html("Rs." + total_price);$("#sub_total_lb").html("Sub Total " + "Rs." + total_price);';
   str_temp += 'if (total_count == 0){$("#empty_cart_mine").removeClass("wer");$("#cart_drawer_footer").addClass("wer");$("#total_cart_money").html("CART");';
   str_temp += '$("#total_cart_money").removeClass("color-green");$("#cart-length-sp").removeClass("cart_green");$("#cart-length-sp").addClass("cart_grey");';
   str_temp += '}}p++;}},error: function() {console.log("delete failed");}});$("#item' + cart_item.id + '").addClass("wer"); });<';
   str_temp += '/script>';


                      // if this added item is first of cart,

                      if (temp_cartCount == 0)
                      {
                        // the blank part of cart drawer will be hidden and submenu will be appeared (and the just added item will be appended.).

                        $("#empty_cart_mine").addClass("wer");
                        $("#cart_drawer_footer").removeClass("wer");
                        $("#li_items").prepend(str_temp);
                      }
                      else {

                        // the just added item will be appended.

                        console.log(str_temp);
                        $("#li_items").prepend(str_temp);
                      }

                    },
                    error: function(result) {}
                  });

	}

	// displaying the Success.

	$('.modal').html('SUCCESSFULLY ADDED TO CART!');
	openModal();
	setTimeout(autocloseModal, 1000);
},
error: addToCartFail
});
}
simply.GetBundleData = function(){
  var ProdHandles = $(".bundle_prod_details").attr('data-ProdHandles');
  var ProdArray = ProdHandles.split(',');
  var DynamicData = "";
  var DynamicURL = "";
  var DynamicSKU = "";
  var DynamicTitle = ""; /*RESPONSE => productResponse.options[0].values (COLOR OPTION) */
  var DynamicWeight = ""; /*RESPONSE => productResponse.options[1].values (SIZE OPTION) */
  var DynamicPrice = ""; /*RESPONSE => productResponse.variants (SIZE OPTION) */
  var fetchedProducts = 0;
  $.each(ProdArray, function (index, value) {
   var value2 = value.replace('tea-', '');
   jQuery.getJSON("/products/"+ value2 +".js", function(productResponse) {
    DynamicTitle = productResponse.title ; /*RESPONSE => productResponse.options[0].values (COLOR OPTION) */
    var variant ;
    if(productResponse.variants[1]){
     variant = productResponse.variants[1];
   }else{
     variant = productResponse.variants[0];
   }
   if($(".bundle_prod_details").attr("data-countryCode") == 'USD'){
    var str = variant.title;
    str = str.substring(0, str.length - 2);
    str = parseFloat(str);
    str = Math.ceil(str * 10) / 10;
    DynamicWeight = str + "oz | 10gm"; /*RESPONSE => productResponse.options[1].values (SIZE OPTION) */
  }
  else{
   DynamicWeight = variant.title;
 }
 DynamicPrice = variant.price / 100;
 DynamicSKU = variant.sku;
 DynamicURL = productResponse.url;
 DynamicData = "<tr><td><a class='text-link-3' href="+DynamicURL+">"+DynamicTitle+"</a></td><td>"+DynamicWeight+"</td><td class='tb-center'>"+ $(".bundle_prod_details").attr("data-currency")+" "+DynamicPrice+"</td></tr>";
 $("#bundle_list").append(DynamicData);
 $("#bundle_list_mobile").append(DynamicData);
 fetchedProducts++;
});
 });
};
simply.mobileButtonScroll = function(){
  if($(window).width() < 768 && $(".xs_desc").length > 0) {

   var btn = $(".normal_products .add_to_cart.buy_me");
   $(window).scroll(function(event) {
    var xs_top = $(".xs_desc").offset().top;
    if($(window).scrollTop() + $(window).height() > xs_top){
     btn.removeClass('fixed_button');
   }
   else{
     btn.addClass('fixed_button');
   }
 });
 }
};

simply.productImageClick = function () {
  $(document).keydown(function(e){
   if( e.keyCode == 27){
    $(".image_zoom_over .close_zoom_image,.scale_image_zoom .close_zoom_image,.vidoe_full_wrapper .close_zoom_image").click();
  }
});
  if($(window).width()<768){
   $("#product_page .visible-xs .product_image img").click(function(event) {
    $("body").css('overflow-y', 'hidden');
    $(".image_zoom_over").removeClass('hidden');
  });

 }
 $("#product_page .product_page_images img").click(function(event) {
   $("body").css('overflow-y', 'hidden');
   $(".image_zoom_over").removeClass('hidden');
 });

 $("#product_page .close_zoom_image").click(function(event) {
   $("body").css('overflow-y', 'scroll');
   $(".image_zoom_over").addClass('hidden');
 });
 $('.image_zoom_over').click(function(event) {
   /* Act on the event */
   $(this).find('.close_zoom_image').click();
 });
};
simply.sizeImageClick = function () {
  $('.scale_image_zoom').click(function(event) {
   /* Act on the event */
   $(this).find('.close_zoom_image').click();
 });
  $("#product_page .product_page_size_images_button,#product_page .size_chart_text a").click(function(event) {
   $("body").css('overflow-y', 'hidden');
   $(".scale_image_zoom").removeClass('hidden');
   if($(window).width()<768){
    $(".visible-xs .image_zoom_over .close_zoom_image").click();
  }
});

  $("#product_page .scale_image_zoom  .next_image").click(function(event) {

   $(this).toggleClass('hidden');
   $(".prev_image").toggleClass('hidden');
   $(".scale_image_zoom .image_class").each(function(index, el) {
    $(el).toggleClass('hidden');
  });
 });

  $("#product_page .scale_image_zoom  .prev_image").click(function(event) {

   $(this).toggleClass('hidden');
   $(".next_image").toggleClass('hidden');
   $(".scale_image_zoom .image_class").each(function(index, el) {
    $(el).toggleClass('hidden');
  });
 });
  $("#product_page .scale_image_zoom  .close_zoom_image").click(function(event) {
   $("body").css('overflow-y', 'scroll');
   $(".scale_image_zoom").addClass('hidden');
 });
};
simply.videoImageClick = function () {
  $("#product_page .video_link_special img").click(function(event) {
   $("body").css('overflow-y', 'hidden');
   $(".vidoe_full_wrapper").removeClass('hidden');
   $(".specialVideoWrapper").removeClass('hidden');
 });

  $("#product_page .vidoe_full_wrapper  .close_zoom_image").click(function(event) {
   $("body").css('overflow-y', 'scroll');
   $(".vidoe_full_wrapper").addClass('hidden');
   stopVideo();
   $(".specialVideoWrapper").removeClass('hidden');
 });
};

simply.swapTinboximg = function(selector){
  if($(selector).hasClass('swatch-tin')){
    if($(window).width() > 767 ){
      $('.my-foto.tin_img img').mouseover();
      if(('#quick_view').length > 0){
       var owl = $(".flexslider .tin_img").attr('data-index');
       owl = parseInt(owl) - 1;
       $('.flexslider').flexslider(owl);
     }
   }
   else{
    var owl = $(".owl-carousel").data('owlCarousel');
    owl.goTo(3);
  }
}
else{
  if($(window).width() > 767 ){
    $('.my-foto img').first().mouseover();
         // if(('#quick_view').length > 0){
         //  $('.flexslider').flexslider(0); 
         // }
       }
       else{
        var owl = $(".owl-carousel").data('owlCarousel');
        owl.goTo(0);
      }
    }
  }

	// simply.specialProductLikeDescription = function(){
		//   $("#product_page .wishlist_product .like_product_special").click(function(event) {
			//     $(this).toggleClass('liked');
			//   });
		//   if($(".special_product_description .description_content").height()>120){
			//     $(".special_product_description .show_more").css('display', 'block');;
			//   }
			//   $("#product_page .show_more").click(function(event) {
				//     $(this).hide();
				//     $("#product_page .show_less").show();
				//     $(".special_product_description .description_content").css('height', '100%');
				//   });
			//   $("#product_page .show_less").click(function(event) {
				//     $(this).hide();
				//     $("#product_page .show_more").show();
				//     $(".special_product_description .description_content").css('height', '150px');
				//   });
			// }

			simply.removeQtyform = function (){
				if($(window).width()<768 && $("#badantam_product").length < 1 ){
					$(".desktop_qty_box").remove();
				}
				else{
					$(".mobile_qty_box").remove();
				}
			};

			simply.extraAddToCartSpeacial = function () {
				$("#product_page .add_to_cart_link").click(function(event) {
					if($("#product_page .add_to_cart_link").attr("href")=="/checkout"){

					}
					else{
						$(" .product_form.hidden-xs #AddToCartForm").submit();
					}
				});
			};

			simply.openSizeText = function(){
				if($(window).width()>1024){
					$(".size_button_wrapper").mouseover(function(event) {
						event.stopPropagation();
						$(".product_page_size_images_button").css('left', '230px');
						$(".size_images_button_text ").addClass('active');
						$(".image_wrapper_special.active").removeClass('active');

					});
					$(".size_button_wrapper").mouseout(function(event) {
						$(".product_page_size_images_button ").css('left', '317px');
						$(".size_images_button_text ").removeClass('active');
					});
				}
			};

			simply.scrollToDetails = function(){
				if($(window).width()>=1024){
					$(".special_product_more_info").click(function(event) {
						// $('html, body').animate({
							//   scrollTop: $(".tb-pg-cnt ").offset().top - 90
							// }, 500);
              $(".floating-nav .nav-tile:first").click();
            });
				}
				if($(window).width()<768){
					$(".special_product_description .show_more").click(function(event) {
						$('html, body').animate({
							scrollTop: $(".xs_desc ").offset().top - 30
						}, 500);
					});
				}

			};

			simply.productImageHover = function(){
				if($(window).width()>1024){
					$(".product_images .image_wrapper_special").mouseover(function(event) {
						$(this).addClass('active');

					});
					$(".product_images .image_wrapper_special").mouseout(function(event) {
						$(this).removeClass('active');
					});
				}
			};

			simply.disableInput =function (){
				if($(window).width()<1024){
					$(".js-quantity-selector").each(function(index, el) {
						$(el).attr('readonly', 'readonly');
					});
				}
				if($(window).width()>767 && $(window).width()<1023){
					$(".acc-usage-cnt .container").removeClass('flex_view');
				}
			};

			simply.variantHover = function (){
				if($("#badantam_product").length>0){

				}
				else{
					$(".special_product_detail .swatch-element").mouseover(function(event) {
						$(this).find(".swatch_inner").addClass('swatch_inner_hover');
						$(this).css('border', '1px solid #000');
					});

					$(".special_product_detail .swatch-element").mouseout(function(event) {
						$(this).find(".swatch_inner").removeClass('swatch_inner_hover');
						if($(this).hasClass('active')){
							$(this).css('border', '1px solid #000');
						}
						else{
							$(this).css('border', 'none');
						}
					});
				}

			};

			simply.scrollOnReview = function(){
				if($(window).width()>1023){
					$(".rating-cnt .stamped-product-reviews-badge").click(function(event) {
						event.stopPropagation();
						if($(".pdt-review-cnt").length > 0){
							$('html, body').animate({
								scrollTop: $(".pdt-review-cnt").offset().top - 120
							}, 800);
						}
					});
				}
			};





			$(document).ready(function(){
        var last = $('.my-foto').last();
        $('.my-foto.tin_img').insertAfter(last);
        if(($('#gallary_product .product-videos')).length>0){
          last = $('#gallary_product .product-videos');
          $('.my-foto.tin_img').insertAfter(last);
        }
        if($(".bundle_prod_details").attr("data-bundlePresent") == "true"){
         simply.GetBundleData();
       }
       simply.removeQtyform();
       simply.productVariantInitialize();
       
       simply.shippinDetails();
       
       simply.mobileButtonScroll();
       simply.productImageClick();
       simply.sizeImageClick();
       simply.videoImageClick();
				// simply.specialProductLikeDescription();
				simply.extraAddToCartSpeacial();
				simply.openSizeText();
				simply.scrollToDetails();
				simply.productImageHover();
				simply.disableInput();
				simply.variantHover();
				simply.scrollOnReview();
				if($(window).width()<768){
					$('.product_image').owlCarousel({
						items: 1,
						lazyLoad: true,
						autoplay:1000,
						center:true,
						video:true,
						videoWidth: 300,
						videoHeight: 300,
						autoPlay: true,
						autoPlaySpeed: 2000,
					});
					$(".like-sugess-product .pdt-img-cnt").removeAttr('target');

					$(".like-sugess-product .col-xs-7 a").removeAttr('target');

					$(".mobile_review").append($("#review-form"));
				}
			});

			// productimage video
			function playVideo(){

				var src = document.getElementById("video").src;
				if(src.indexOf("&autoplay")>0){
					src = src.replace("&autoplay=0", "&autoplay=1");
				}else{
					src += "&autoplay=1";
				}
				if( /Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ){
					//alert("im found");
					document.getElementById("video").src = src;
					document.getElementById("video_div_mobile").classList.remove("hidden");
					document.querySelector("body").classList.add("scroll_block");
					document.getElementById("navbar_id").classList.add("hidden");
					if(window.innerHeight < window.innerWidth){
						document.querySelector(".pdt-detail-cnt").classList.add("hidden");
					}
				}else{
					document.getElementById("video").src = src;
					document.getElementById("image_content").classList.add("hidden");
					document.getElementById("video_content").classList.remove("hidden");
					// document.getElementById("thumbnail_play").classList.add("hidden");
					// document.getElementById("thumbnail_stop").classList.remove("hidden");
				}
			}
			function stopVideo(){
				var src = document.getElementById("video").src;
				var src2 = document.getElementById("video2").src;
				src = src.replace("&autoplay=1", "&autoplay=0");
				src2 = src2.replace("&autoplay=1", "&autoplay=0");
				if( /Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ){
					document.getElementById("video").src = src;
					document.getElementById("video2").src = src2;
					document.getElementById("video_div_mobile").classList.add("hidden");
					document.querySelector("body").classList.remove("scroll_block");
					document.getElementById("navbar_id").classList.remove("hidden");
					if(window.innerHeight < window.innerWidth){
						document.querySelector(".pdt-detail-cnt").classList.remove("hidden");
					}
				}else{
					document.getElementById("video").src = src;
					document.getElementById("video2").src = src2;
					document.getElementById("video_content").classList.add("hidden");
					document.getElementById("image_content").classList.remove("hidden");
					// document.getElementById("thumbnail_stop").classList.add("hidden");
					// document.getElementById("thumbnail_play").classList.remove("hidden");
				}

			}
			window.addEventListener("orientationchange", function() {
				if(window.orientation == 90 || window.orientation == -90){
					if(!document.getElementById("video_div_mobile").classList.contains("hidden")){
						document.querySelector(".pdt-detail-cnt").classList.add("hidden");
					}
				}else{
					if(!document.getElementById("video_div_mobile").classList.contains("hidden")){
						document.querySelector(".pdt-detail-cnt").classList.remove("hidden");
					}
				}
			}, false);

			window.onclick = function (event) {
				var clickedOnElement = event.target.classList.contains("filter-arrow-black") ||
				event.target.classList.contains("toggle-child-cnt") ||
				event.target.classList.contains("filter-arrow-black") ||
				event.target.parentElement.id === "more-child-cnt" ||
				event.target.id === "more-child-cnt";

				if(!clickedOnElement && !$(".hidden-child-cnt").hasClass("hidden")){
					$(".hidden-child-cnt").addClass("hidden");
				}
			}